var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.667,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_155_12)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 28.4169L28.9586 31.5831L35.125 25.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4996 44.25L31.856 43.6481C34.7001 42.3946 37.156 40.3659 38.9577 37.7816C40.7595 35.1973 41.8384 32.1559 42.0776 28.9869L42.7407 20.2469C42.7515 19.885 42.641 19.5302 42.4276 19.2419C42.2142 18.9536 41.911 18.7493 41.5685 18.6631L30.4996 15.75L19.4307 18.6C19.0883 18.6862 18.7852 18.8904 18.5718 19.1785C18.3585 19.4666 18.2479 19.8213 18.2585 20.1831L18.9216 28.9231C19.1606 32.0922 20.2395 35.1337 22.0413 37.7182C23.843 40.3026 26.299 42.3315 29.1432 43.585L30.4996 44.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_12",
    x1: 30.667,
    y1: 0,
    x2: 30.667,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/Integrity.15859a97a46b1b59a096380324272bea.svg";
export { ForwardRef as ReactComponent };